$(function(){
	if ($('.stepsModule-tab-container').length > 0){
		comprobarstepsModule();

		$(window).resize(function() {
			comprobarstepsModule();
		})

		$(".stepsModule-tab").on("click", function(){
			if (!$(this).hasClass("stepsModule-tab-active")) {
				$(".stepsModule-tab").removeClass("stepsModule-tab-active");
				$(".stepsModule-content").removeClass("stepsModule-content-active");
				$(this).addClass("stepsModule-tab-active");
				var tabToShow = $(this).data("step-index");
				var indexTab = tabToShow;
				tabToShow = tabToShow+1;
				$(".stepsModule-content:nth-of-type("+tabToShow+")").addClass("stepsModule-content-active");
				$('.stepsModule-tab-container').slick('slickGoTo', indexTab);
			}
		})

		// CREACIÓN DE IFRAME DE VIDEO EN STEPSMODULE
		$(".content-video-stepsModule").each(function() {
			var strVideo = $(this).data('video-id');
			var id = 'player-' + Date.now() + parseInt(Math.random() * 100000000);
			if (strVideo.indexOf("?") == -1 ){
				$(this).append('<iframe id="'+ id + '" src="https://www.youtube.com/embed/' + strVideo + '?rel=0&enablejsapi=1" width="100%" height="100%" frameborder="0" allowfullscreen></iframe>');
			}
			else {
				$(this).append('<iframe id="'+ id + '" src="https://www.youtube.com/embed/' + strVideo + '&rel=0&enablejsapi=1" width="100%" height="100%" frameborder="0" allowfullscreen></iframe>');
			}
		});

		// FIN CREACIÓN DE IFRAME DE VIDEO EN STEPSMODULE
	}
})

function comprobarstepsModule() {
	if (window.innerWidth < 800 && $('.stepsModule-tab-container').find(".slick-list.draggable").length < 1){
		$('.stepsModule-tab-container').slick({
			dots: false,
			infinite: false,
			slidesToShow: 3,
			slidesToScroll: 1,
			arrows: true,
			variableWidth: true
		});
	}
	else if (window.innerWidth > 799 && $('.stepsModule-tab-container').find(".slick-list.draggable").length > 0) {
		$('.stepsModule-tab-container').slick('unslick');
	}
}